// extracted by mini-css-extract-plugin
module.exports = {"h1":"H1_h1__3trWj"};